import { Expose } from 'class-transformer'
import { User } from 'react-feather'

import { Base } from './Base'

export class Client extends Base {
  static type = 'client'
  static typeDisplay = 'Client'
  static icon = User

  type = Client.type
  typeDisplay = Client.typeDisplay
  icon = Client.icon

  guid: string = ''

  name: string = ''

  @Expose({ name: 'is_active' })
  isActive: boolean = true
}
